import "../../assets/css/report/report.css"

import Axios from "axios"
import { useEffect, useState } from "react"

import { useGeneralStates } from "../../context/general-context"
import { ACTIONS } from "../../utils/globalUtils.js"
import InputsSection from "./inputsSection.jsx"
import ErrorSection from "./errorSection.jsx"
import loadingGif from "../../assets/images/loading.gif"

export default function Report() {
    const { dispatch } = useGeneralStates()
    
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    useEffect(() => {
        handleFetchCities()
    }, [])
    
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Cancel the event as returning a non-void value will prompt a confirmation dialog
            event.preventDefault();
            // Chrome requires returnValue to be set
            event.returnValue = '';

            // Perform any additional cleanup or logic you need before the page unloads
            // For example, you might want to save data or show a confirmation message
            // console.log("User is trying to leave the page");
        };

        // Add the event listener when the component mounts
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    function handleFetchCities() {
        setLoading(true)
        Axios.get(process.env.REACT_APP_TEASER_CITIES).then(res => {
            setError("")
            setLoading(false)
            dispatch({ type: ACTIONS.setTeaserCities, payload: res.data })
        }).catch(err => {
            setLoading(false)
            setError(err?.response?.data?.message || "Error retrieving cities information")
        })
    }

    if (loading) return <section className="loadingImage"><img src={loadingGif} alt="Prodensa Teaser"/></section>
    
    return (
        <section className="reportSection">
            <div className="headerSection">
                <div className="titleSection">
                    <h1>Inputs</h1>
                    <span>Select the appropriate values for each input field to generate a report. These inputs help in customize the report content to better match criteria and provide relevant insights.</span>
                </div>
            </div>

            {!error ? 
                <InputsSection />
                :
                <ErrorSection error={error} handleFetchCities={handleFetchCities} />
            }
        </section>
    )
}
